export const fieldObjectRelatorios = {
  id: 'ID',
  dtRelatorioGerado: 'Data/Hora de Geração',
  usuario: 'Usuário',
  dsTemplate: 'Template Utilizado',
  nVisualizacoes: 'Número de Visualizações',
  dtUltimaVisualizacao: 'Última Visualização',
  observacoes: 'Observações',
};

export const headersMeusRelatorios = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 20, key: 'ID' },
  { text: 'Data Gerada', width: 20, key: 'Data Gerada' },
  { text: 'Titulo', width: 35, key: 'titulo' },
  //{ text: 'Template', width: 25, key: 'template' },
  //{ text: 'Visualizações', width: 150, key: 'Visualizações' },
  { text: 'Última Visualização', width: 70, key: 'Última Visualização' },
  //{ text: 'Link', width: 200, key: 'Observações' },
];

export const valoresExibidosRelatorios = {
  ID: 'ID',
  'Data Gerada': 'Data Gerada',
  Usuário: 'Usuário',
  Titulo: 'Titulo',
  // Template: 'Template',
  Visualizações: 'Visualizações',
  'Última Visualização': 'Última Visualização',
  Observações: 'Observações',
};
